import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { jwtDecode } from "jwt-decode";
import { JSX, useEffect } from "react";

interface Props {
  children: JSX.Element;
  roles?: string[];
}

interface JwtPayload {
  uid: string;
  companyId: string;
  companyRole: string;
  role?: string;
  roles?: string[];
  exp: number;
}

export default function AuthGuard({ children, roles }: Props) {
  const { token, logout } = useAuth();

  useEffect(() => {
    if (!token) {
      logout();
    } else {
      try {
        const payload: JwtPayload = jwtDecode(token);
        // Check if token is expired
        if (payload.exp * 1000 < Date.now()) {
          logout();
        }
      } catch (error) {
        // If decoding fails, token is invalid
        logout();
      }
    }
  }, [token, logout]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  try {
    const payload: JwtPayload = jwtDecode(token);

    // Check expiry
    if (payload.exp * 1000 < Date.now()) {
      return <Navigate to="/login" replace />;
    }

    // Optional role-based restriction
    // if (roles) {
    //   const rawRoles = payload.roles || payload.role || [];
    //   const userRoles: string[] = Array.isArray(rawRoles) ? rawRoles : [String(rawRoles)];

    //   const hasRole = roles.some(r => 
    //     userRoles.some(ur => ur && ur.toLowerCase() === r.toLowerCase()) || 
    //     (payload.companyRole && payload.companyRole.toLowerCase() === r.toLowerCase())
    //   );
    //   if (!hasRole) {
    //     return <Navigate to="/" replace />;
    //   }
    // }
  } catch {
    return <Navigate to="/login" replace />;
  }

  return children;
}
